import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAppContext } from '../contexts/AppContext';
import { getSlugFromPage } from '../utils/routeUtils';
import {
  capturePageview,
  identifyUser,
  resetUser,
} from '../lib/analytics/posthog';

/** Identify/reset + SPA pageviews (funciona em rotas públicas e autenticadas). */
export function usePostHogAnalytics(): void {
  const { user, isAuthenticated } = useAuth();
  const { currentPage } = useAppContext();

  useEffect(() => {
    if (!isAuthenticated || !user?.id) {
      resetUser();
      return;
    }

    identifyUser(user.id, {
      email: user.email,
      name: user.user_metadata?.full_name ?? user.user_metadata?.name,
    });
  }, [isAuthenticated, user?.id, user?.email, user?.user_metadata]);

  useEffect(() => {
    const slug = getSlugFromPage(currentPage);
    const path = slug ? `/${slug}` : window.location.pathname;
    capturePageview(currentPage, path);
  }, [currentPage, isAuthenticated]);
}
